var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitoringLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-28.000000, -172.000000)",
    fill: "#4A5866",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar",
    transform: "translate(-1.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Monitoring",
    transform: "translate(29.000000, 156.273429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2222222,1.7265711 L1.77777778,1.7265711 C0.8,1.7265711 0,2.5265711 0,3.50434887 L0,15.9487933 C0,16.9265711 0.8,17.7265711 1.77777778,17.7265711 L14.2222222,17.7265711 C15.2,17.7265711 16,16.9265711 16,15.9487933 L16,3.50434887 C16,2.5265711 15.2,1.7265711 14.2222222,1.7265711 Z M4.44444444,14.1710155 L4.44444444,14.1710155 C3.95555556,14.1710155 3.55555556,13.7710155 3.55555556,13.2821267 L3.55555556,10.61546 C3.55555556,10.1265711 3.95555556,9.7265711 4.44444444,9.7265711 C4.93333333,9.7265711 5.33333333,10.1265711 5.33333333,10.61546 L5.33333333,13.2821267 C5.33333333,13.7710155 4.93333333,14.1710155 4.44444444,14.1710155 Z M8,14.1710155 L8,14.1710155 C7.51111111,14.1710155 7.11111111,13.7710155 7.11111111,13.2821267 L7.11111111,12.3932378 C7.11111111,11.9043489 7.51111111,11.5043489 8,11.5043489 C8.48888889,11.5043489 8.88888889,11.9043489 8.88888889,12.3932378 L8.88888889,13.2821267 C8.88888889,13.7710155 8.48888889,14.1710155 8,14.1710155 Z M8,9.7265711 C7.51111111,9.7265711 7.11111111,9.3265711 7.11111111,8.83768221 C7.11111111,8.34879332 7.51111111,7.94879332 8,7.94879332 C8.48888889,7.94879332 8.88888889,8.34879332 8.88888889,8.83768221 C8.88888889,9.3265711 8.48888889,9.7265711 8,9.7265711 Z M11.5555556,14.1710155 L11.5555556,14.1710155 C11.0666667,14.1710155 10.6666667,13.7710155 10.6666667,13.2821267 L10.6666667,6.17101554 C10.6666667,5.68212665 11.0666667,5.28212665 11.5555556,5.28212665 C12.0444444,5.28212665 12.4444444,5.68212665 12.4444444,6.17101554 L12.4444444,13.2821267 C12.4444444,13.7710155 12.0444444,14.1710155 11.5555556,14.1710155 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringLight);
export default __webpack_public_path__ + "static/media/monitoring-light.570293e79d8c7bade95cfefab3897b8f.svg";
export { ForwardRef as ReactComponent };